module.exports = __webpack_public_path__ + "img/Icon-sidebar-log-out.4d9dfc2f.svg";